/**
 * Partially applies a function by fixing some arguments, returning a new function
 * that only needs the remaining arguments.
 *
 * @param {Function} fn - The function to partially apply.
 * @param {...*} fixedArgs - The arguments to fix in place for the function.
 * @returns {Function} A new function that takes the remaining arguments and calls `fn` with both fixed and remaining arguments.
 *
 * @example
 * const add = (a, b) => a + b;
 * const addFive = partial(add, 5);
 * addFive(3); // returns 8
 */
export const partial =
  (fn, ...fixedArgs) =>
  (...remainingArgs) =>
    fn(...fixedArgs, ...remainingArgs)
